<template>
    <div :class="`click-and-drag-block ${!show ? 'hidden' : ''}`" @click="clickHandler">
        <div class="click-and-drag"></div>
    </div>
</template>

<script>
    import lottie from 'lottie-web'

    export default {
        props: {
            show: {
                type: Boolean,
                default: true
            },
        },

        methods: {
            clickHandler() {
                this.show = false
            }
        },

        mounted () {
            lottie.loadAnimation({
                container: document.querySelector('.click-and-drag'), // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: this.asset('images/click-drag.json') // the path to the animation json
            })
        },
    }
</script>

<style lang="scss" scoped>
    .click-and-drag-block {
        width: 100%;
        height: 100%;
        position: absolute;
        transition: opacity .5s;

        &.hidden {
            opacity: 0;
        }

        .click-and-drag {
            width: 124px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
            pointer-events: none;
            opacity: 1;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/motor-show/ClickAndDrag.vue